module.exports = __webpack_public_path__ + "img/dynameat-logo-primary.aa14f9bf.png";